/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */
import React, { useEffect } from 'react';
import { bool, func, object } from 'prop-types';

import { makeStyles } from '@material-ui/core/styles';
import { useDispatch, useSelector } from 'react-redux';
import MarkdownText from './Partials/MarkdownText';
import OfferButton from './Partials/OfferButton';
import { setOfferInboxOffers } from '../../../../../../state/ducks/App/App-Actions';
import { getOfferInboxOfferPayloadById } from '../../../../../../state/ducks/App/App-Selectors';
import noop from '../../../../../helpers/noop';

const useStyles = makeStyles((theme) => ({
    container: {
        border: '1px solid transparent',
        borderImage: 'repeating-linear-gradient(45deg, #D9D9D9 0 5px, transparent 5px 10px) 1',
        borderImageSlice: 1,
        borderRadius: '6px',
        padding: '18px',
        display: 'grid',
        gridTemplateColumns: '25% 25% calc(50% - 60px) 60px',
        alignItems: 'center',
    },
    icon: {
        gridColumn: '4 / 5',
        gridRow: '1 / 3',
        justifySelf: 'flex-end',
    },
    topMargin: {
        marginTop: '24px',
    },
    button: {
        gridColumn: 'span 2',
    },
    leftMarkdown: {
        gridColumn: '1 / 4',
    },
    fullMarkdown: {
        gridColumn: 'span 4',
    },
}));

const WithRightIcon = ({ offer, notFirst, trackClickThrough }) => {
    const dispatch = useDispatch();

    const isOfferGateway = offer?.type === 'offer-gateway';
    const offerUID = isOfferGateway ? offer?.content?.uid : offer?.uid;
    const offerData = useSelector((state) => getOfferInboxOfferPayloadById(state, offerUID));
    const classes = useStyles();

    const structure = (isOfferGateway ? offer?.content?.structure : offer?.structure) || [];

    useEffect(() => {
        const stateMap = {};
        if (!offerData?.buttonState) {
            structure?.forEach((item) => {
                if (item?.button) {
                    const { button_id, button_state } = item.button;
                    // Only add if button_id is not null/undefined and not already added
                    if (button_id !== null && !(button_id in stateMap)) {
                        stateMap[button_id] = button_state;
                    }
                }
            });

            const offerPayload = {
                offerId: offerUID,
                offer: {
                    buttonState: stateMap,
                },
            };

            dispatch(setOfferInboxOffers(offerPayload));
        }
    }, []);

    const renderStructureItem = (item, index) => {
        const keys = Object.keys(item);
        const data = item[keys[0]];

        switch (keys[0]) {
            case 'text':
                return (
                    <div className={data.full_width ? classes.fullMarkdown : classes.leftMarkdown} key={index}>
                        <MarkdownText key={index} data={data} />
                    </div>
                );

            case 'icon':
                return (
                    <div className={classes.icon} key={index}>
                        <img
                            src={data?.file?.url}
                            alt={item.alt || 'Offer Image'}
                            style={{ maxWidth: '100%' }}
                        />
                    </div>
                );

            case 'button':
                return (
                    <OfferButton
                        key={index}
                        buttonData={data}
                        offer={offer}
                        className={classes.button}
                        trackClickThrough={trackClickThrough}
                    />
                );

            default:
                return null;
        }
    };

    return (
        <>
            <div className={`${classes.container} ${notFirst ? classes.topMargin : ''}`}>
                {
                    structure?.map((item, index) => (renderStructureItem(item, index)))
                }
            </div>
        </>
    );
};

WithRightIcon.propTypes = {
    offer: object,
    notFirst: bool,
    trackClickThrough: func,
};

WithRightIcon.defaultProps = {
    offer: {},
    notFirst: false,
    trackClickThrough: noop,
};

export default WithRightIcon;
